import { render, staticRenderFns } from "./zinputcurrency.vue?vue&type=template&id=5974dde6&"
import script from "./zinputcurrency.vue?vue&type=script&lang=js&"
export * from "./zinputcurrency.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports